// extracted by mini-css-extract-plugin
module.exports = {"disableLinkTel":"bankTransfer_disableLinkTel__3beIZ","qrCodeContainer":"bankTransfer_qrCodeContainer__1Nhk-","qrCodeFixed":"bankTransfer_qrCodeFixed__1-UG5"};